import { Box, Typography, Tooltip } from '@mui/material';

const FlightBar = ({ flight, startMins, durationMins, color, hourWidth = 56, rowHeight = 32 }) => {
  const left  = (startMins / 60) * hourWidth;
  const width = Math.max((durationMins / 60) * hourWidth, 28);

  return (
    <Tooltip
      arrow
      title={
        <Box>
          <Typography variant="caption" fontFamily="monospace" fontWeight="bold">
            {flight.carrier}{flight.flightNo} {flight.dep}→{flight.arr}
          </Typography>
          <br />
          <Typography variant="caption">
            {flight.std}→{flight.sta}{flight.nextDay ? `+${flight.nextDay}` : ''}
          </Typography>
          <br />
          <Typography variant="caption">
            AC: {flight.acType || '-'} · {flight.sectorType}
          </Typography>
        </Box>
      }
    >
      <Box
        sx={{
          position: 'absolute',
          left,
          width,
          top: 3,
          height: rowHeight - 8,
          bgcolor: color,
          borderRadius: '3px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          px: 0.5,
          overflow: 'hidden',
          '&:hover': { opacity: 0.85, filter: 'brightness(1.15)' },
        }}
      >
        <Typography
          variant="caption"
          fontFamily="monospace"
          fontWeight="bold"
          sx={{ color: '#fff', fontSize: '0.6rem', whiteSpace: 'nowrap' }}
        >
          {flight.carrier}{flight.flightNo}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default FlightBar;
